export const ADD_FILE_DETAIL = 'ADD_FILE_DETAIL';
export const UPDATE_FILE_DETAIL = 'UPDATE_FILE_DETAIL';

export const updateFileDetail = (fileDetail) => ({
    type: UPDATE_FILE_DETAIL,
    payload: fileDetail,
});

const initialState = {
    load: false,
    currentIndex: null,
    failedRows: null,
    enteredRows: null
};

export const fileDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_FILE_DETAIL:
            const value = action.payload
            return {
                ...state, ...value
            };

        default:
            return state;
    }
};

